import isString from 'lodash/isString';
import { parsePhoneNumberFromString } from 'libphonenumber-js';
import { exception } from '@/exceptions/Exceptions';

/**
 * Get format options for telephone number.
 *
 * @param {String}      telephone
 * @param {String|null} countryCode
 *
 * @returns {Object}
 *
 * @throws {Error}
 */
export const formatTelephoneNumber = (telephone, countryCode = null) => {
    if (!telephone || !isString(telephone) || telephone.length < 10) exception('Invalid telephone number');

    if (!countryCode) countryCode = process.env.VUE_APP_COUNTRY_ISO;

    // Phone library requires country ISO 2 not ISO 3.
    countryCode = countryCode.substring(0, 2);

    let formattedTelephoneNumber = parsePhoneNumberFromString(telephone, countryCode);

    return formattedTelephoneNumber;
};

/**
 * Check if telephone number valid.
 *
 * @param {String}      telephone
 * @param {String|null} countryCode
 *
 * @returns {Boolean}
 */
export const isTelephoneNumberValid = (telephone, countryCode = null) => {
    try {
        let formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode);

        return formattedTelephoneNumber.isValid();
    } catch (error) {
        return false;
    }
};

/**
 * Format telephone to international format.
 *
 * @param {String}      telephone
 * @param {String|null} countryCode
 *
 * @returns {String}
 *
 * @throws {Error}
 */
export const telephoneNumberInternationlFormat = (telephone, countryCode = null) => {
    let formattedTelephoneNumber = formatTelephoneNumber(telephone, countryCode);

    return formattedTelephoneNumber.format('INTERNATIONAL');
};
